<template>
  <div>
    {{ date }}
  </div>
</template>

<script>
import {formatDate} from '@/utilities/utils'

export default {
  props: ['data'],
  computed: {
    date() {
      if (!this.data) {
        return ''
      }
      return formatDate(this.data)
    }
  }
}
</script>
